export const PriceElasticityDashboardErrorText = {
  NoDataAvailableError: 'We are unable to retrieve your data at this time.',
};

export class NoDataAvailableError extends Error {
  constructor() {
    super(PriceElasticityDashboardErrorText.NoDataAvailableError);
  }
}
